import {
  FETCH_LEAVE_PRIOR_LIST_REQUEST,
  FETCH_LEAVE_PRIOR_LIST_SUCCESS,
  FETCH_LEAVE_PRIOR_LIST_FAILURE,
  FETCH_NOT_APPROVED_LEAVE_PRIOR_REQUEST,
  FETCH_NOT_APPROVED_LEAVE_PRIOR_SUCCESS,
  FETCH_NOT_APPROVED_LEAVE_PRIOR_FAILURE,
  UPDATE_LEAVE_PRIOR_REQUEST,
  UPDATE_LEAVE_PRIOR_SUCCESS,
  UPDATE_LEAVE_PRIOR_FAILURE,
} from "../constants/LeavePriorConstants";

const initialState = {
  leavePriorList: [],
  leavePriorListLoading: false,
  leavePriorListError: null,

  notApprovedList: [],
  notApprovedListLoading: false,
  notApprovedListError: null,

  updateLoading: false,
  updateSuccessCount: 0,
  updateError: null,
};

export const LeavePriorReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LEAVE_PRIOR_LIST_REQUEST:
      return { ...state, leavePriorListLoading: true, leavePriorListError: null };
    case FETCH_LEAVE_PRIOR_LIST_SUCCESS:
      return { ...state, leavePriorList: action.payload || [], leavePriorListLoading: false };
    case FETCH_LEAVE_PRIOR_LIST_FAILURE:
      return { ...state, leavePriorList: [], leavePriorListError: action.payload, leavePriorListLoading: false };

    case FETCH_NOT_APPROVED_LEAVE_PRIOR_REQUEST:
      return { ...state, notApprovedListLoading: true, notApprovedListError: null };
    case FETCH_NOT_APPROVED_LEAVE_PRIOR_SUCCESS:
      return { ...state, notApprovedList: action.payload || [], notApprovedListLoading: false };
    case FETCH_NOT_APPROVED_LEAVE_PRIOR_FAILURE:
      return { ...state, notApprovedList: [], notApprovedListError: action.payload, notApprovedListLoading: false };

    case UPDATE_LEAVE_PRIOR_REQUEST:
      return { ...state, updateLoading: true, updateError: null, updateSuccessCount: 0 };
    case UPDATE_LEAVE_PRIOR_SUCCESS:
      return { ...state, updateLoading: false, updateSuccessCount: action.payload };
    case UPDATE_LEAVE_PRIOR_FAILURE:
      return { ...state, updateLoading: false, updateError: action.payload };

    default:
      return state;
  }
};